import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReportTab from '../ReportTab';
import BtnRefresh from '../buttons/BtnRefresh';
import BtnExpand from '../buttons/BtnExpand';
import RptMultiTotal from './views/RptMultiTotal';

import { errorMessage, catName, tlzName, onlyUnique, cmp, rptTotal, rptTotalQty } from '../functions';

const mapStateToProps = (state) => {
        return {
		apiServer: state.apiServer,
		agent: state.agent,
		uid: state.uid,
		session: state.session,
                periodType: state.periodType,
                periodDate: state.periodDate
        }
}

const mapDispatchToProps = { errorMessage }

function RptOthersCategoryMultiTotal(props){
	const [rpt_cat, setRptCat] = useState([]);

	const refresh = () => {
		console.log('RptOthersCategoryMultiTotal.js refresh invoked');

		var F1031 = props.periodType;
		var F254 = props.periodDate;

		console.log('RptOthersCategoryMultiTotal.js requesting: ' + props.apiServer + '?uid='+props.uid+'&session='+props.session+'&action=rpt_cat&agent='+props.agent+'&F1031='+F1031+'&F254='+F254);
		fetch(props.apiServer + '?uid='+props.uid+'&session='+props.session+'&action=rpt_cat&agent='+props.agent+'&F1031='+F1031+'&F254='+F254)
		.then(response => response.json())
		.then(result => {
			console.log('RptOthersCategoryMultiTotal.js rpt_cat result returned');
			console.log('RptOthersCategoryMultiTotal.js rpt_cat result: '+JSON.stringify(result));
			if(result.data){
							setRptCat(result.data);
			}
			else{
				props.errorMessage("Error retrieving rpt_cat data: "+result.message);
			}
		});
	}

	// FORMAT REPORT DATA FOR MULTI TOTAL REPORT
	var rptData = rpt_cat.map((record) => record.F17).filter(onlyUnique).sort().map((catNo) => {
		return ({
			description: catNo + ' ' + catName(rpt_cat, catNo),
			data: rpt_cat.filter((data) => data.F17 === catNo).sort(function (a, b) {
				return cmp(a.F1179, b.F1179) || cmp(a.F1034, b.F1034);
			}).map((record) => record.F1034).filter(onlyUnique).map((totalizer) => {
				return ({
					code: totalizer,
					description: tlzName(rpt_cat, totalizer),
					qty: rptTotalQty(rpt_cat.filter((rpt) => rpt.F17 === catNo), totalizer),
					dollars: rptTotal(rpt_cat.filter((rpt) => rpt.F17 === catNo), totalizer)
				})
			})
		});
	});
	console.log('RptOthersCategoryMultiTotal.js rptData = '+JSON.stringify(rptData));

	return (
		<ReportTab id='CategoryMultiTotals'>
			<ReportTab.Header parentId='CategoryMultiTotals' title='Category Multi Totals'>
				<BtnRefresh parentId='CategoryMultiTotals' action={refresh} />
				<BtnExpand parentId='CategoryMultiTotals' action={refresh} />
			</ReportTab.Header>
			<ReportTab.Expand parentId='CategoryMultiTotals'>
				<RptMultiTotal data={rptData} />
			</ReportTab.Expand>
		</ReportTab>
	);
}

export default connect(
        mapStateToProps,
        mapDispatchToProps
)(RptOthersCategoryMultiTotal);

